import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import { FlatButton, Dialog } from 'material-ui'
import InnerRequestReviewButton from './InnerRequestReviewButton'
import css from './request-review-buttons.css'

class RequestReviewButtons extends Component {
  state = {
    menuOpen: false,
    textDisabled: false,
    emailDisabled: false,
  }

  toggleMenu = menuOpen => this.setState({ menuOpen })

  sendRequestReview = (type) => {
    const {
      appointment: { id: appointmentId, patient_id: patientId },
      requestReview,
    } = this.props
    requestReview(patientId, appointmentId, type).then(res =>
      this.updateReviewButtonState(type, res),
    )
  }

  handleRequestReview = type =>
    this.updateReviewButtonState(type, true, () => this.sendRequestReview(type))


  updateReviewButtonState = (type, value, callback = null) =>
    this.setState({ [`${type}Disabled`]: value }, callback)


  render() {
    const { small, appointment } = this.props
    const { emailDisabled, textDisabled, menuOpen } = this.state
    const buttonStyles = small ? {
      padding: '0px',
      top: '5px',
      minWidth: '22px',
    } : {
      padding: '0 5px',
      top: '-6px',
    }

    return (
      <div>
        <FlatButton onClick={() => this.toggleMenu(true)} style={buttonStyles}>
          {small ? <MoreVertIcon /> : (
            <div className={css.buttonText}>Request Review</div>
          )}
        </FlatButton>
        <Dialog
          open={menuOpen}
          onRequestClose={() => this.toggleMenu(false)}
          maxWidth="sm"
        >
          <div className={css.dialogWrapper}>
            <div className={css.header}>Request Review</div>
            <div className={css.buttons}>
              <InnerRequestReviewButton
                type="email"
                appointment={appointment}
                disableButton={emailDisabled}
                requestReview={this.handleRequestReview}
              />
              <InnerRequestReviewButton
                type="text"
                appointment={appointment}
                disableButton={textDisabled}
                requestReview={this.handleRequestReview}
              />
            </div>
            <div className={css.closeButton}>
              <FlatButton
                onClick={() => this.toggleMenu(false)}
                style={{ color: '#6040B0' }}
              >
                Close
              </FlatButton>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
}

RequestReviewButtons.propTypes = {
  appointment: PropTypes.shape({
    review_requested_by_text: PropTypes.bool,
    review_requested_by_email: PropTypes.bool,
    reviews: PropTypes.arrayOf(PropTypes.object),
  }),
  requestReview: PropTypes.func.isRequired,
  small: PropTypes.bool,
}

export default RequestReviewButtons



// WEBPACK FOOTER //
// ./src/components/sitewide/Reviews/RequestReviewButtons.js